<template>
<div>
    <Header />
    <Stepper v-if="!submitting" :stepper="stepper" @step="goToStep" @submit="onSubmit" />
    <NavButtons v-if="!submitting" :stepper="stepper" />

    <div v-if="!loading && !submitting" class="form-container">
        <vm-form v-show="stepper.key == 'key2'">
            <Economy :customer="customer" />
            <ShippingTable v-model="shipping" :thresholdValues="thresholdValues" />
	        
	        <vm-card :header="__('additional_info')">
		        
		        <template v-slot:actions>
		        <vm-tooltip-action :html="__('additional_info_tt')"/>
		        </template>
		        
		        <vm-group c12 class="af-textarea">
			        <vm-label :text="flow.additionalInfo.length + '/' + __('additional_info_max')"/>
			        <textarea :maxlength="__('additional_info_max')"
			                  :placeholder="__('additional_info_ph')"
			                  v-model="flow.additionalInfo"></textarea>
		        </vm-group>
	        </vm-card>
	        
        </vm-form>

        <vm-form v-show="stepper.key == 'key3'">
            <vm-card list :header="__('approval')">
                <vm-row>
                    <vm-group c12>
                        <vm-label :text="__('approve_question')" />
                        <vm-checkbox inline radio
                            v-model="approveModel"
                            @input="validateInputs"
                            :options="{
                                approved: { label: __('yes') },
                                rejected: { label:  __('no') }
                        }"/>
                    </vm-group>
                    <vm-group c12 v-if="approveModel.rejected">
                        <vm-label :text="__('approve_message')" />
                        <vm-input v-model="approveMessage" @input="validateInputs" />
                    </vm-group>
                </vm-row>
            </vm-card>
        </vm-form>
    </div>

    <div v-if="submitted" class="main-message card-shadow">
        <div style="width: 400px; margin-left: -200px; text-align: center; margin-bottom: 30px; margin-top: 20px;">
            <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(2.0);">
                <path d="M16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32ZM13 19.4L23 10C23.5 9.5 24.3 9.5 24.8 10C25.3 10.5 25.3 11.2 24.8 11.7L13.9 22C13.7 22.2 13.3 22.3 13 22.3C12.7 22.3 12.3 22.2 12.1 22L7.1 17.4C6.6 16.9 6.6 16.2 7.1 15.7C7.6 15.2 8.4 15.2 8.9 15.7L13 19.4Z"/>
            </svg>
        </div>
        <div style="width: 400px; margin-left: -200px; text-align: center; font-size: 18px;">
            <p>Fraktavtalen er sendt tilbake til selger.</p>
            <p>Du kan nå lukke fanen.</p>
        </div>
    </div>

</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import maxbo from '../maxbo';
import log from '../log';
import shippingapi from '../shippingapi';
import verified from '../verified';

import Header from '../components/nav/Header';
import Stepper from '../components/nav/Stepper';
import NavButtons from '../components/nav/NavButtons';

import Economy from '../components/Economy';
import ShippingTable from '../components/ShippingTable';

export default {
name: 'Approve',
components: {
    Header,
    Stepper,
    NavButtons,
    Economy,
    ShippingTable
},
data() {
    return {
        loading: true,
        submitting: false,
        submitted: false,
        stepper: {
            step: 1,
            steps: [],
            key: ''
        },
        customer: {},
        shipping: {},
        flow: {
	        additionalInfo: ''
        },
        approveModel: {
            approved: false,
            rejected: false
        },
        approveMessage: '',
        thresholdValues: []
    }
},
methods: {
    // --- Stepper Logic --------------------------------
    goToStep(key) {
        for (let i in this.stepper.steps) {
            if (this.stepper.steps[i].key == key) {
                this.stepper.step = Number(i) + 1;
                this.stepper.key = key;
            }
        }
    },
    updateStep(key, name, value) {
        for (let i in this.stepper.steps) {
            if (this.stepper.steps[i].key == key) {
                this.stepper.steps[i][name] = value;
            }
        }
    },
    initSteps() {
        this.stepper.steps = [
            {
                key: 'key2',
                label: 'Fraktavtale',
                pDisabled: true, nDisabled: false,
                pText: 'Tilbake', nText: 'Neste'
            },
            {
                key: 'key3',
                label: 'Godkjenning',
                pDisabled: false, nDisabled: true,
                pText: 'Tilbake', nText: 'Send inn'
            }
        ]
        this.goToStep('key2');
    },
    // --------------------------------------------------
    validateInputs() {
        if (this.approveModel.approved) this.updateStep('key3', 'nText', 'Godkjenn');
        if (this.approveModel.rejected) this.updateStep('key3', 'nText', 'Avslå');
        if (this.approveModel.approved || (this.approveModel.rejected && this.approveMessage.length > 0)) {
            this.updateStep('key3', 'nDisabled', false);
        }else {
            this.updateStep('key3', 'nDisabled', true);
        }
    },
    async onSubmit() {
        this.submitting = true;
        this.$parent.setLoading(true, this.approveModel.approved ? 'Godkjenner fraktavtale...' : 'Avslår fraktavtale...');

        const pdfStrings = shippingapi.getPDFValues(this.shipping, this.$parent.sheetData.values);
        
        // Set recipient action
        const flowStep = Number(this.flow.step) + 1;
        let action = 'confirm';
        let actor = this.flow.editor;

        // Get envelope from parent-view
        const envelope = this.$parent.getEnvelope();

        // Set recipient
        if (this.approveModel.approved) {
            await verified.setRecipient(envelope, 'associate', this.flow.editor);
        }else {
            action = 'edit';
            await verified.setRecipient(envelope, 'editor', this.flow.editor);
        }

        // Prepare mail
        const mail = {
            step: flowStep,
            action: action,
            subject: 'Fraktavtale godkjent',
            title: 'Avtalen ble godkjent',
            message: `Hei ${this.flow.editor.fname}, ${this.flow.approver.fname} har godkjent avtalen din`,
            button: 'Bekreft',
            hint: 'Trykk på knappen for å gå til skjema og bekrefte avtalen. NB! Det er viktig at du gjøre dette for at alt skal bli rett lagret i arkivet.'
        }
        if (this.approveModel.rejected) {
            mail.subject = 'Fraktavtale ikke godkjent';
            mail.title = 'Fraktavtale ikke godkjent';
            mail.message = `Hei ${this.flow.editor.fname}, ${this.flow.approver.fname} godkjente ikke avtalen din. Åpne skjema for å se hvorfor og endre avtalen.`;
            mail.button = 'Åpne skjema';
            mail.hint = 'Klikk på knappen for å gå til skjema og endre avtalen.';
        }

        // Prepare flow status
        this.flow.status = {
            wasApproved: this.approveModel.approved,
            wasRejected: this.approveModel.rejected,
            message: this.approveMessage
        }
        this.flow.step = flowStep;
        this.flow.action = action;
        this.flow.actor = actor;

        // Prepare userdata
        const userdata = {
            customer: this.customer,
            shipping: this.shipping,
            flow: this.flow,
            mail: mail,
            pdfStrings: pdfStrings
        };

        // Set userdata and trigger next recipient
        await verified.setUserdata(envelope, userdata);

        if (this.approveModel.approved) {
            // Update shipping table
            await shippingapi.overwriteShipping(this.customer.number, this.shipping);
            log.s('shipping table updated');
        }

        this.$parent.setLoading(false);
        this.submitted = true;
    }
},
async created() {
	
    this.$parent.setLoading(true, 'Laster inn data...');

    this.initSteps();

    // Get cached data from parent-view
    this.customer = await this.$parent.getCustomer();
    this.shipping = await this.$parent.getShipping();
    this.flow = this.$parent.getFlow();

    // Prepare shipping object
    shippingapi.setMaxDiscounts(this.shipping, this.$parent.sheetData.values);
    shippingapi.setOriginalPrices(this.shipping, this.$parent.sheetData.values);

    this.thresholdValues = shippingapi.getThresholdValues(this.$parent.sheetData.thresholds);
    
    this.loading = false;
    this.$parent.setLoading(false);
}
}
</script>
<style scoped>

.af-textarea .vm-label {
	text-align: right;
	color: #959595;
}

.af-textarea textarea {
	width: calc(100% - 6px);
	border: 1px solid #d3d3d3;
	border-bottom: 2px solid rgb(0, 73, 118);
	resize: vertical;
	min-height: 36px;
	font-size: 15px;
	font-family: inherit;
	outline: none;
	padding: 8px;
}

</style>